
document.addEventListener("DOMContentLoaded", function () {
  const testimonialSlider = document.querySelector(".splide.hello");
  const marqueeSlider = document.querySelectorAll(".splide.splide_text");
  const setSlider = document.querySelector('.splide.uni-sets-slider')

  if (setSlider) {
    new Splide(setSlider, {
      perPage: 2.5,
      rewind: true,
    }).mount();
  }

  if (testimonialSlider) {
    new Splide(testimonialSlider, {
      type: "loop",
      padding: "15rem",
      gap: "36px",
      breakpoints: {
        1200: {
          perPage: 2,
          padding: '10px',
          gap: "20px"
        },
        800: {
          perPage: 1,
          padding: '10px',
          gap: "20px"
        },
      },
    }).mount();
  }

  if ((marqueeSlider, length > 0)) {
    marqueeSlider.forEach((single) => {
      new Splide(single, {
        type: "loop",
        drag: "free",
        focus: "center",
        pagination: false,
        arrows: false,
        perPage: 4,
        autoScroll: {
          speed: 2.1,
          pauseOnHover: false,
        },
        breakpoints: {
          1200: {
            perPage: 2,
          },
          800: {
            perPage: 1,
          },
        },
      }).mount(window.splide.Extensions);
    });
  }

})